module.exports = __webpack_public_path__ + "static/eye_of_fear_and_flame-abf6e7dd7656b8668107119b600f46e9.jpeg";